var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"new-advert-subtitle"},[_vm._v("Фотографии:")]),_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',[_c('UploadImages',{on:{"set-files":_vm.setFiles}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }